<h3 translate>m2.sprint5.cockpit.card.chart.kennzahlenDerMethodik.diagramm</h3>
<div id="svgContenairRisikopaare" style="padding-bottom: 30px;" class="cockpit-svg-image"></div>
